import * as React from 'react';

import { GenericDropdownBuilder } from '../../form/dropdown/index';
import RadioSelect from '@components/form/radio-select';
import styled from 'styled-components';
import { Translate } from 'react-localize-redux';

export type MerchSizeSelectorOptions = {
  id: number;
  label: string;
  selected?: boolean;
}[];

interface MerchSizeSelectorProps {
  className?: string;
  sizes: MerchSizeSelectorOptions;
  onChange: (data: MerchSizeSelectorOptions) => void;
}

const DropdownCtrl = GenericDropdownBuilder();

export const MerchSizeSelector: React.FC<MerchSizeSelectorProps> = ({
  className,
  sizes,
  onChange,
}) => {
  const selectedSizes = sizes.filter((s) => s.selected);

  const allSizesSelected = selectedSizes.length === sizes.length;

  const getValue = () => {
    if (!selectedSizes.length) {
      return undefined;
    }
    if (allSizesSelected) {
      return 'All Sizes'; //<Translate id="MERCH.SECTIONS.COLOR.AVAILABLE.SIZES.SELECT.HELP"/>
    }
    return selectedSizes.map((s) => s.label).join(', ');
  };

  const handleAllSizes = () => {
    if (allSizesSelected) {
      onChange((sizes = []));
    } else {
      onChange(
        sizes.map((s) => {
          return {
            ...s,
            selected: true,
          };
        })
      );
    }
  };

  return (
    <div className={className}>
      <DropdownCtrl
        title={
          <Translate id="MERCH.SECTIONS.COLOR.AVAILABLE.SIZES.SELECT.LABEL" />
        }
        value={getValue()}
      >
        <RadioSelect
          className="radio-size"
          isChecked={allSizesSelected}
          onChange={handleAllSizes}
        >
          <Translate id="MERCH.SECTIONS.COLOR.AVAILABLE.SIZES.SELECT.HELP" />
        </RadioSelect>
        {sizes.map((size, i) => (
          <RadioSelect
            key={`size-selected-${i}`}
            className="radio-size"
            isChecked={size.selected}
            onChange={() =>
              onChange(
                sizes.map((s) => {
                  if (s.id === size.id) {
                    return {
                      ...s,
                      selected: !s.selected,
                    };
                  } else {
                    return s;
                  }
                })
              )
            }
          >
            {size.label}
          </RadioSelect>
        ))}
      </DropdownCtrl>
    </div>
  );
};

export default styled(MerchSizeSelector)`
  .radio-size {
    margin-top: 14px;

    &:first-child {
      margin-top: 0;
    }
  }
`;
